import styled, { css } from 'styled-components';

export const SalesReportContainer = styled.div`
    flex: 1;
    display: flex;
`;

export const SalesContentWrapper = styled.div`
    width: 100%;
    max-width: 475px;
    display: flex;
    flex-direction: column;
    gap: 32px;
`;
export const SalesReportDescription = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;

    @media (max-width: 425px) {
        flex-direction: column;
    }
`;

export const DescriptionText = styled.h3`
    display: flex;
    flex-direction: column;
    font-size: 22px;
    font-weight: 700;
    font-style: bold;
    line-height: 1.36;
`;
export const DescriptionRateText = styled.span`
    ${(props) =>
        props.$salesTrend &&
        props.$salesTrend === 'INCREASE' &&
        css`
            color: #ef2b2a;
        `}
    ${(props) =>
        props.$salesTrend &&
        props.$salesTrend === 'DECREASE' &&
        css`
            color: #0066ff;
        `}
    ${(props) =>
        props.$salesTrend &&
        props.$salesTrend === 'SAME' &&
        css`
            color: #757575;
        `}
`;

export const DescriptionUl = styled.ul`
    width: 161px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    font-size: 10px;
    font-weight: 700;
    line-height: 1.5;
    font-style: bold;
    padding: 0px;
    margin: 0px;

    @media (max-width: 425px) {
        width: 100%;
        font-size: 16px;
        font-style: semibold;
        font-weight: 600;
    }
`;
